var $export = require('./_export');
var define = require('./_object-define');

$export($export.S + $export.F, 'Object', { define: define });



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/modules/core.object.define.js
// module id = 526
// module chunks = 0